import { useContext } from "react";
import { LangContext } from "../contexts/LangContext";
import templateTree from "./templateTree";
import templateData from "./templateData";

export function useTemplates() {
  const { lang } = useContext(LangContext);

  // Дерево для текущего языка (fallback на en)
  const tree = templateTree[lang] || templateTree["en"];

  // Получить данные шаблона с локализованными строками
  const getTemplate = (templateId) => {
    const tpl = templateData[templateId];
    if (!tpl) return null;
    return {
      ...tpl,
      meta: {
        ...tpl.meta,
        name: tpl.meta.name[lang] || tpl.meta.name["en"],
        desc: tpl.meta.desc[lang] || tpl.meta.desc["en"],
      },
      prefill: {
        ...tpl.prefill,
        taskName: tpl.prefill.taskName[lang] || tpl.prefill.taskName["en"],
      },
    };
  };

  return { tree, getTemplate };
}